// extracted by mini-css-extract-plugin
module.exports = {"item":"dropdown-offers_item__kUX_i","selected":"dropdown-offers_selected__un4Bf","itemChip":"dropdown-offers_itemChip__ouIq5"};